import { inject, injectable } from 'inversify';
import React from 'react';

import { User } from '@project44/ui-utils';

import { UserPrincipalUIService } from '../../application/UserPrincipal.ui.service';
import { TLogoutCard } from '../../infrastructure/ui/LogoutCard/LogoutCard.view';

@injectable()
export class UserPrincipalUIController {
  constructor(
    @inject(UserPrincipalUIService)
    private readonly userPrincipalUIService: UserPrincipalUIService,
  ) {}

  public createLogoutCardComponent(payload: {
    user: User;
  }): React.ReactElement<TLogoutCard> {
    return this.userPrincipalUIService.createLogoutCardComponent(payload);
  }
}
